<template>
  <div id="mse">
    <!-- <div class="start-button" @click="startPlay">
      {{ play_status === 1?'未开始':(play_status === 2?'直播中':'观看回放' )}}
    </div>-->
  </div>
</template>
<script>
import 'xgplayer';
import HlsPlayer from 'xgplayer-hls';
import api from '../api/api';

export default {
  props: ['url', 'danmu', 'showDanmu', 'liveUuid', 'cover', 'play_status'],
  data() {
    return {
      player: null,
      timer: new Date().getTime(),
      overdanmu: [],
      startTime: '',
      overTime: '',
      videoTimer: ''
    };
  },
  watch: {
    showDanmu(val) {
      if (val == true) {
        this.player.danmu.stop(); // 弹幕停止并消失
      } else {
        this.player.danmu.play(); // 弹幕继续播放
      }
    },
    danmu(newValue, oldValue) {
      if (!(this.player && this.player.danmu)) {
        return;
      }
      this.danmu.forEach(it => {
        let tim = new Date(it.create_time).getTime() - this.timer;
        if (tim < 0) {
          tim = 3000;
        }
        this.player.danmu.sendComment({
          // 发送弹幕
          duration: 15000,
          id: it.id,
          // start: 3000,
          start: tim,
          txt: it.detail,
          style: {
            color: '#ff9500',
            fontSize: '20PX',
            border: 'solid 1PX #ff9500',
            borderRadius: '50PX',
            padding: '5PX 11PX',
            backgroundColor: 'rgba(255, 255, 255, 0.1)'
          }
        });
      });
    },
    pause() {
      this.player.once('pause', () => {
        console.log('暂停');
        this.overTime = this.player.video.currentTime;
        this.liveSendTime();
      });
    }
  },
  beforeDestroy() {
    clearInterval(this.videoTimer);
    this.videoTimer = null;
    this.player.once('destroy', () => {
      this.overTime = this.player.video.currentTime;
      this.liveSendTime();
    });
    // this.player.once('pause', () => {
    //   console.log('暂停');
    //   this.overTime = this.player.video.currentTime;
    //   this.liveSendTime();
    // });
    this.player.destroy(true);
  },
  mounted() {
    this.player = new HlsPlayer({
      id: 'mse',
      width: '100%',
      height: '100%',
      isLive: true,
      ignores: ['time', 'progress'],
      preloadTime: 30,
      minCachedTime: 5,
      lang: 'zh-cn',
      url: this.url,
      poster: this.cover,
      danmu: {
        panel: false, // 弹幕面板
        comments: [],
        area: {
          // 弹幕显示区域
          start: 0, // 区域顶部到播放器顶部所占播放器高度的比例
          end: 100 // 区域底部到播放器顶部所占播放器高度的比例
        },
        closeDefaultBtn: true, // 开启此项后不使用默认提供的弹幕开关，默认使用西瓜播放器提供的开关
        defaultOff: false // 开启此项后弹幕不会初始化，默认初始化弹幕
      }
    });
    this.player.once('play', () => {
      console.log('开始');
      this.videoTimer = setInterval(() => {
        console.log('____________');
        setTimeout(this.liveSendTime(), 0);
      }, 5000);
      console.log(this.player);
      this.startTime = this.player.video.currentTime;
      console.log(this.startTime);
    });
    this.danmu.forEach(it => {
      this.player.danmu.sendComment({
        // 发送弹幕
        duration: 15000,
        id: it.id,
        start: 3000,
        txt: it.detail,
        style: {
          color: '#ff9500',
          fontSize: '20PX',
          border: 'solid 1PX #ff9500',
          borderRadius: '50PX',
          padding: '5PX 11PX',
          backgroundColor: 'rgba(255, 255, 255, 0.1)'
        }
      });
    });
    // const that = this;
    // console.log(this.player._played);
    // if (this.player._played) {
    //   this.videoTimer = setInterval(() => {
    //     console.log('____________');
    //     setTimeout(this.liveSendTime(), 0);
    //   }, 5000);
    // }
  },
  methods: {
    startPlay() {
      if (this.play_status === 1) {
        this.$message.warning('直播未开始！');
        return;
      }
      this.player.once('play', () => {
        console.log('开始');
        this.liveSendTime();
        console.log(this.player);
        this.startTime = this.player.video.currentTime;
        console.log(this.startTime);
      });
    },
    // 直播计时
    liveSendTime() {
      this.startTime = this.overTime;
      this.overTime = this.player.video.currentTime;
      console.log(this.overTime);
      console.log(this.startTime);
      const params = {
        live_uuid: this.liveUuid,
        count_time: this.overTime - this.startTime
      };
      console.log(params);
      if (params.count_time == 0) {
        return;
      }
      api.liveSendTime(params).then(res => {
        console.log('计时成功');
      });
    }
  }
};
</script>
<style>
.xgplayer-skin-default .xgplayer-panel-slider {
  bottom: 40PX;
  font-size: 12PX;
  height: auto;
}
#mse {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.start-button {
  position: absolute;
  z-index: 999;
  top: 44%;
  left: 50%;
  transform: translate(-50%);
  width: 288PX;
  height: 80PX;
  margin: 0 auto;
  font-size: 30PX;
  color: #ffffff;
  text-align: center;
  line-height: 80PX;
  background-color: #f1a373;
  border-radius: 6PX;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/videoPlayer.vue